/**
 * Falha na requisição de dados de voos já reportada ao Sentry por
 * `fetchFlightData`, com URL, status e duração. Quem captura este erro não
 * deve reportá-lo de novo.
 */
export class FlightDataRequestError extends Error {
  constructor(cause: unknown) {
    super("Erro ao buscar os dados de voos", { cause });
    this.name = "FlightDataRequestError";
  }
}
